import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiRoutes, apiRequest } from "../../services";
import Paths from "../../paths";
import { Loading } from "./validateStyled";

export default function Validate() {
  const history = useNavigate();

  const createSession = async (code: string | null) => {
    const [error, data] = await apiRequest({
      method: "post",
      url: `${apiRoutes["login"]}`,
      data: { code: code },
    });
    if (!error) {
      localStorage.setItem("token", data.csg_pd_access_token);
        history(Paths.Home);
    } else {
      history(Paths.Unauthorized);
    }
  };

  useEffect(() => {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const code = params.get("code");
    createSession(code);
  }, []); // eslint-disable-line

  return (
    <Loading>
      <p>Please wait</p>
      <span>
        <i></i>
        <i></i>
      </span>
    </Loading>
  );
}
